import React from 'react'
import { Grid2 } from '@mui/material'
import { ContactMobileHero } from './ContactMobileHero'
import { ContactConnectMobile } from './ContactConnectMobile'
import { ContactLocationMobile } from './ContactLocationMobile'

export function ContactMobile() {
  return (
   <>
   <Grid2 >
        <ContactMobileHero/>
        <ContactLocationMobile/>
        <ContactConnectMobile/>
    </Grid2>
   </>
  )
}

 